import type { ReactNode } from "react";

import InputTextArea from "@/components/Input/InputTextArea";

import {
  CFormItemBase,
  type CFormItemProps,
  buildCFormItem,
} from "../CFormItem";

type Props = CFormItemProps & {
  value?: string;
  onChange: (value?: string) => void;
  disabled?: boolean;
  inputWidth?: number | string;
  readComponent?: ReactNode;
  placeholder?: string;
  rows?: number;
  maxLength?: number;
};

export const CFormTextAreaItem = buildCFormItem<Props>((props: Props) => {
  const {
    value,
    onChange,
    disabled,
    inputWidth,
    readComponent,
    placeholder,
    rows = 3,
    maxLength,
    ...restProps
  } = props;

  return (
    <CFormItemBase
      {...restProps}
      readComponent={
        readComponent ?? <p className="whitespace-pre-wrap">{value}</p>
      }
      writeComponent={
        <InputTextArea
          id={props.id}
          value={value ?? ""}
          width={inputWidth ?? "100%"}
          onChange={(e) => onChange?.(e.target.value || undefined)}
          disabled={disabled || props.readonly}
          placeholder={placeholder}
          rows={rows}
          maxLength={maxLength}
        />
      }
    />
  );
});
